import { colors } from '@/theme/colors';

export type HamburgerProps = {
  color?: string;
};

export default function Hamburger({ color = colors.neutral100 }: HamburgerProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox={`0 0 24 24`}>
      <path
        fill={color}
        fillRule="nonzero"
        d="M21 17.253a.75.75 0 0 1 .102 1.493l-.102.007H3a.75.75 0 0 1-.102-1.493L3 17.253h18zm0-6a.75.75 0 0 1 .102 1.493l-.102.007H3a.75.75 0 0 1-.102-1.493L3 11.253h18zm0-6a.75.75 0 0 1 .102 1.493L21 6.753H3a.75.75 0 0 1-.102-1.493L3 5.253h18z"
      ></path>
    </svg>
  );
}
